export enum FeatureFlagKeys {
  COPY_ITEM = 'ab_copy_item',
  CURRENCY_CONFIGURATION = 'ab_currency_configuration',
  DIGITAL_PORTFOLIO = 'ab_digital_portfolio',
  ITEM_TRANSFER = 'ab_item_transfer',
  LINK_IN_BIO = 'ab_link_in_bio',
  MARK_AS_SOLD = 'ab_mark_as_sold',
  NOTIFICATIONS = 'ab_notifications',
  PAYMENT_SETTINGS = 'ab_payment_settings',
  TEAM = 'ab_team',
  VIEWING_ROOMS = 'ab_viewing_rooms',
  SECTORS = 'ab_sectors',
  MAGIC_LINK_LOGIN = 'ab_magic_link_login',
  CHUNKED_ART_UPLOAD = 'ab_chunked_art_upload',
  COLLABORATORS = 'ab_collaborators',
  ARTISTS = 'ab_artists',
  GALLERY_PROFILE = 'ab_gallery_profile',
  AUTH0_MIGRATION = 'auth0mig',
}
